var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMoreIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_4451",
    "data-name": "Groupe 4451",
    transform: "translate(-265 -210)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_35",
    "data-name": "Ellipse 35",
    cx: 7,
    cy: 7,
    r: 7,
    transform: "translate(265 210)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3196",
    "data-name": "Rectangle 3196",
    width: 1,
    height: 8,
    rx: 0.5,
    transform: "translate(271.5 213)",
    fill: "#015c7e"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3197",
    "data-name": "Rectangle 3197",
    width: 1,
    height: 8,
    rx: 0.5,
    transform: "translate(276 216.5) rotate(90)",
    fill: "#015c7e"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoreIcon);
export default __webpack_public_path__ + "static/media/more-icon.5be5b15eb349ac91cd53ff49b9ca8ff1.svg";
export { ForwardRef as ReactComponent };